export default __webpack_public_path__ + "static/media/idcard.01ac2618.jpg";